module.exports = __webpack_public_path__ + "static/media/Ary de Farias_Anjos de Deus_front cover.e43fbfe1.jpg";